import { companyInfo } from '@stores/atoms/company';
import { atom } from 'jotai';

export const getSettingFooterInfo = atom((get) => {
  const info = get(companyInfo);

  return {
    managerName: info.managerName,
    managerEmail: info.managerEmail,
    managerPhone: info.managerPhone,
  };
});
